import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoy = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 428.049,
	height: 783.658,
	viewBox: "0 0 428.049 783.658",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "CHILDREN_CHARACTER_SET",
		"data-name": "CHILDREN CHARACTER SET",
		transform: "translate(-630.397 553.838)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Gruppe_73",
			"data-name": "Gruppe 73",
			transform: "translate(-66 -769)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Pfad_72",
					"data-name": "Pfad 72",
					d: "M838.005,714.243c-.855,0-1.853-.143-2.709-.143-5.418.143-10.978.428-16.4.713Z",
					transform: "translate(52.158 212.434)",
					fill: "#e4e5e6"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Pfad_73",
					"data-name": "Pfad 73",
					d: "M746.9,756.679c22.385,16.4,52.611,15.969,80.271,14.971,17.252-.713,34.5-1.283,51.755-2,9.268-.285,18.678-2.566,27.945-1.283,12.974,1.854,11.834,9.268,20.816,14.828,5.133,3.137,11.406,3.279,17.394,3.279,30.939,0,61.879-.143,92.675-.143,19.248,0,39.779-.428,56.033-10.979,6.986-4.562,13.117-12.119,11.834-20.246-1.711-10.693-14.4-15.113-24.951-16.967a351.057,351.057,0,0,0-73.285-5.275c-13.26.428-26.8,1.568-39.779-1.568-8.127-2-15.683-5.7-23.525-8.555-23.81-8.7-49.617-9.268-75.138-8.412.855,0,1.854.143,2.709.143l-19.105.57c5.418-.285,10.836-.57,16.4-.713a361.163,361.163,0,0,0-85.831,5.988c-13.117,2.566-26.8,5.988-36.785,15.113-3.85,3.564-7.129,8.7-5.846,13.687C741.483,752.259,744.192,754.682,746.9,756.679Z",
					transform: "translate(18.651 212.343)",
					fill: "#e4e5e6"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Gruppe_72",
					"data-name": "Gruppe 72",
					transform: "translate(696.397 215.162)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_74",
							"data-name": "Pfad 74",
							d: "M941.788,721.837l-12.4-31.937L899.3,693.464s7.984,11.549,7.129,24.808C905.573,731.675,941.788,721.837,941.788,721.837Z",
							transform: "translate(-610.007 -13.032)",
							fill: "#fbbb8c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_75",
							"data-name": "Pfad 75",
							d: "M836.263,722.1c.285-1.426,2.852-5.7.285-14.258a64.6,64.6,0,0,1-2.566-16.539L802.9,694.437s3.422,13.117,3.422,19.39S835.978,723.522,836.263,722.1Z",
							transform: "translate(-651.051 -12.436)",
							fill: "#fbbb8c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_76",
							"data-name": "Pfad 76",
							d: "M845.278,755.655s7.7-118.909,20.246-120.763C878.07,632.9,944.8,753.8,949.644,753.8h37.64s-25.094-83.122-33.791-113.064-21.244-81.982-21.244-81.982-44.484,11.406-84.12,8.555-58.884-9.41-58.884-9.41-10.408,21.814-5.561,64.3,26.8,133.452,26.8,133.452Z",
							transform: "translate(-659.781 -69.234)",
							fill: "#505050"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_77",
							"data-name": "Pfad 77",
							d: "M939.081,713.594c-19.533-17.537-62.449-88.826-72.144-93.673s-19.533,2-30.226,24.381-17.537,107.361-17.537,107.361,1.568,1.711,3.564,3.992h21.814s7.7-118.909,20.246-120.763c12.547-2,79.273,118.909,84.121,118.909h37.64s-25.094-83.122-33.791-113.064-21.244-81.982-21.244-81.982-44.484,11.406-84.12,8.555-58.884-9.41-58.884-9.41-2.424,5.133-4.42,15.113c5.275,7.557,11.264,14.971,15.4,20.674,9.7,13.687,49.759,10.693,76.136,7.842,26.377-2.994,43.914-3.85,54.607,9.7,10.693,13.687,38.068,111.21,38.068,111.21S958.615,731.274,939.081,713.594Z",
							transform: "translate(-659.056 -69.234)",
							fill: "#454545"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_78",
							"data-name": "Pfad 78",
							d: "M940.017,616.366c0-9.125-6.7-65.728-7.842-94.244s-3.422-53.894-6.844-58.457S896.674,459.1,875,455.682c0,0-37.783-9.125-48.048-3.422S791.595,576.445,783.61,608.525s53.609,31.652,100.517,32.793C931.035,642.315,940.017,625.491,940.017,616.366Z",
							transform: "translate(-659.564 -115.011)",
							fill: "#7cd1e3"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_79",
							"data-name": "Pfad 79",
							d: "M796.8,631.227c20.531,6.7,53.609,6.844,81.412,7.414,46.908,1.141,55.89-15.683,55.89-24.808s-6.7-65.728-7.842-94.244c-1.141-28.658-3.422-53.894-6.844-58.457-2.139-2.852-12.262-3.85-24.808-5.133,5.133,9.98,18.107,39.922,6.986,63.874-13.687,29.228-28.23,41.918-28.23,59.455s9.7,30.226,1,39.066C867.946,624.811,817.188,624.669,796.8,631.227Z",
							transform: "translate(-653.648 -112.62)",
							fill: "rgba(25,155,181,0.63)"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_80",
							"data-name": "Pfad 80",
							d: "M907.9,540.732Z",
							transform: "translate(-606.345 -76.589)",
							fill: "#fbbb8c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_81",
							"data-name": "Pfad 81",
							d: "M921.864,547.5a27.275,27.275,0,0,0-3.564.285A6.454,6.454,0,0,0,921.864,547.5Z",
							transform: "translate(-601.917 -73.662)",
							fill: "#fbbb8c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_82",
							"data-name": "Pfad 82",
							d: "M933.714,550.416c2.139-6.273.855-13.545.713-14.115s-17.252-6.7-17.252-6.7-10.836,6.273-14.4,11.691-2.709,8.555,1.141,8.84c3.422.285,6.558-3.85,7.129-4.562a.14.14,0,0,1,.143-.143l-.143.143c-.713,1-5.133,7.7.143,12.974,5.561,5.7,13.545,5.988,17.252,3.85s5.133-5.7,3.992-6.7c-.428-.428-1.711-.428-2.994-.428a6.51,6.51,0,0,1-3.564.285,27.275,27.275,0,0,1,3.564-.285A7.767,7.767,0,0,0,933.714,550.416Z",
							transform: "translate(-609.489 -81.283)",
							fill: "#fbbb8c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_83",
							"data-name": "Pfad 83",
							d: "M951.241,572.261s26.234-26.234,21.387-51.613-62.734-61.166-73.142-65.158S870.4,467.609,870.4,467.609s17.109,16.4,23.525,33.078c0,0,33.363,7.984,39.779,20.674s-7.984,41.347-7.984,41.347Z",
							transform: "translate(-622.311 -113.108)",
							fill: "#199bb5"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_84",
							"data-name": "Pfad 84",
							d: "M696.4,403.808c.285,8.127,15.541,13.83,15.826,15.256.285,1.283,15.256,14.543,24.666,15.256s13.83-13.117,13.83-13.117,7.129-38.5-2-36.785-9.125,16.967-9.125,16.967S724.346,373.724,719.356,379s6.416,20.246,5.133,20.246-21.957-19.961-22.67-11.549,8.84,18.535,8.84,18.535S696.116,395.681,696.4,403.808Z",
							transform: "translate(-696.397 -145.69)",
							fill: "#fbbb8c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_85",
							"data-name": "Pfad 85",
							d: "M758.07,483.034c25.664,20.388,80.414,26.662,80.414,26.662l29.8-32.365s2.281-8.7-21.957-13.26c0,0-29.371,5.988-55.89-7.557C764.058,442.97,741.389,405.9,741.389,405.9L721,424.15S732.406,462.646,758.07,483.034Z",
							transform: "translate(-685.922 -133.951)",
							fill: "#199bb5"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_86",
							"data-name": "Pfad 86",
							d: "M813.731,758.942c16.111-1.711,14.971-8.84,24.666-10.551s17.109-12.262,17.109-12.262a51.152,51.152,0,0,0,0-14.4,125.31,125.31,0,0,0-3.279-16.111c-.57-1.711-3.279,1.141-4.848,3.279-1.568,2.281-11.834-1.711-21.957-4.42-5.418-1.426-8.84-1-10.693-.143a4.805,4.805,0,0,0-2.852,3.137c-1.283,3.85-5.133,13.973-14.258,19.818-11.264,7.271-18.82,16.539-18.82,22.242C779.085,761.081,797.763,760.653,813.731,758.942Z",
							transform: "translate(-661.312 -7.221)",
							fill: "#be1e2d"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_87",
							"data-name": "Pfad 87",
							d: "M777.523,748.471c.57,3.992,5.275,7.7,14.4,8.555s28.943-1.568,35.074-4.99,7.414-4.277,14.115-7.414,15.969-11.977,15.969-11.977a35.31,35.31,0,0,0,.855-6.416,33.769,33.769,0,0,0-1.283-7.129s-5.988,10.551-12.832,12.4-13.545,6.416-19.676,9.268-23.953,7.129-34.789,4.563c-10.836-2.709-7.129-9.268-7.129-9.268C778.379,738.063,777.1,744.479,777.523,748.471Z",
							transform: "translate(-661.889 -0.6)",
							fill: "#f5e18d"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_88",
							"data-name": "Pfad 88",
							d: "M904.68,745.873c4.848,5.133,15.969,3.992,21.387,4.277s9.98,1.426,19.105,4.277,19.961,4.277,29.086,1.426,16.254-13.687,9.41-20.246c-7.414-7.129-18.82-12.547-29.656-18.82-8.127-4.705-10.836-10.123-11.691-12.4a2.03,2.03,0,0,0-1.854-1.283,28.8,28.8,0,0,0-11.121,3.137c-6.558,3.422-16.254,3.992-21.672,1.711a18.385,18.385,0,0,0-6.416-1.568,1.829,1.829,0,0,0-1.854,2c.285,2.566.713,6.844.285,9.268C899.262,721.065,899.832,740.74,904.68,745.873Z",
							transform: "translate(-609.969 -7.412)",
							fill: "#be1e2d"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_89",
							"data-name": "Pfad 89",
							d: "M976.2,735.908c-8.555,3.992-22.67,2-30.226-.285s-14.115-4.562-25.949-4.277a33.757,33.757,0,0,1-19.533-5.418c-1,2.994.428,11.691,3.422,13.973s18.107,2.281,23.668,2.566,6.558,2,22.385,5.561,29.941-1,32.793-3.992a16.324,16.324,0,0,0,4.277-11.121c0-3.564-3.992-7.414-3.992-7.414S984.758,732.058,976.2,735.908Z",
							transform: "translate(-609.633 2.125)",
							fill: "#f5e18d"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_90",
							"data-name": "Pfad 90",
							d: "M802.247,703.441c7.984.285,36.072,1.141,38.211.428,1.854-.57,1.711-8.412,1.426-12.547a2.5,2.5,0,0,0-2.424-2.424c-7.414-.143-30.512-.855-38.781-1a2.59,2.59,0,0,0-2.566,2.994l1.711,10.408A2.716,2.716,0,0,0,802.247,703.441Z",
							transform: "translate(-653.107 -13.884)",
							fill: "#2c2c2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Pfad_91",
							"data-name": "Pfad 91",
							d: "M899.994,707.881c8.7-1.426,42.631-7.129,43.058-7.557.428-.57-3.422-12.547-3.707-13.117-.285-.428-33.363,4.563-43.344,6.131a2.356,2.356,0,0,0-1.854,3.137l3.279,9.838A2.389,2.389,0,0,0,899.994,707.881Z",
							transform: "translate(-612.269 -14.19)",
							fill: "#2c2c2c"
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Gruppe_71",
							"data-name": "Gruppe 71",
							transform: "translate(65.013)",
							children: [
								/* @__PURE__ */ _jsx("g", {
									id: "Gruppe_63",
									"data-name": "Gruppe 63",
									transform: "translate(0 167.608)",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "Gruppe_62",
										"data-name": "Gruppe 62",
										children: [/* @__PURE__ */ _jsx("path", {
											id: "Pfad_92",
											"data-name": "Pfad 92",
											d: "M777.931,390.721l3.279-40.92s-16.539-30.226-31.51-10.266-5.846,45.2,7.984,54.179C771.515,402.412,777.931,390.721,777.931,390.721Z",
											transform: "translate(-741.996 -332.719)",
											fill: "#fbbb8c"
										}), /* @__PURE__ */ _jsx("path", {
											id: "Pfad_93",
											"data-name": "Pfad 93",
											d: "M973.676,410.766c14.971-6.559,28.088-30.084,16.4-52.183-11.549-22.1-32.793,5.133-32.793,5.133L954,404.635C954,404.777,958.563,417.324,973.676,410.766Z",
											transform: "translate(-651.73 -325.388)",
											fill: "#fbbb8c"
										})]
									})
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Pfad_94",
									"data-name": "Pfad 94",
									d: "M853.423,484.983c11.121,0,17.68-2.281,21.529-4.42a11.58,11.58,0,0,0,5.418-6.986l2.709-10.408a11.538,11.538,0,0,0-9.41-14.258L843.3,444.633a11.362,11.362,0,0,0-12.832,9.41l-1.711,9.98a10.889,10.889,0,0,0,.855,6.7C831.894,476.143,838.453,484.983,853.423,484.983Z",
									transform: "translate(-705.137 -117.507)",
									fill: "#efaf83"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Pfad_95",
									"data-name": "Pfad 95",
									d: "M860.035,547.967a98.135,98.135,0,0,0,10.123,3.85,102.1,102.1,0,0,0,46.765,3.707c4.563-.713,8.127-1.568,10.551-2.139a73.8,73.8,0,0,1,9.41-2c101.8-16.254,107.5-106.077,107.5-106.077,12.119-129.745-54.75-174.372-87.685-188.344a88.041,88.041,0,0,0-29.656-6.7c-3.137-.143-6.131-.285-9.268-.285-2.994-.428-5.988-.855-9.125-1.141a90.819,90.819,0,0,0-30.369,2C843.5,259.39,770.354,292.753,761.657,422.784c0,0-8.555,89.538,89.253,121.9A69.6,69.6,0,0,1,860.035,547.967Z",
									transform: "translate(-733.705 -201.022)",
									fill: "#fbbb8c"
								}),
								/* @__PURE__ */ _jsxs("g", {
									id: "Gruppe_68",
									"data-name": "Gruppe 68",
									transform: "translate(85.215 205.136)",
									children: [/* @__PURE__ */ _jsxs("g", {
										id: "Gruppe_65",
										"data-name": "Gruppe 65",
										children: [/* @__PURE__ */ _jsxs("g", {
											id: "Gruppe_64",
											"data-name": "Gruppe 64",
											children: [
												/* @__PURE__ */ _jsx("path", {
													id: "Pfad_96",
													"data-name": "Pfad 96",
													d: "M853.671,385.788c1-12.4-10.978-25.664-23.383-26.662s-27.375,6.7-28.373,19.105,12.4,24.666,24.808,25.664C839.128,404.751,852.673,398.049,853.671,385.788Z",
													transform: "translate(-801.72 -359.039)",
													fill: "#3d1629"
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Pfad_97",
													"data-name": "Pfad 97",
													d: "M853.571,387.388c1-12.4-10.979-25.664-23.383-26.662s-27.375,6.7-28.373,19.105,12.4,24.666,24.808,25.664S852.573,399.792,853.571,387.388Z",
													transform: "translate(-801.763 -358.358)",
													fill: "#fff"
												}),
												/* @__PURE__ */ _jsx("circle", {
													id: "Ellipse_24",
													"data-name": "Ellipse 24",
													cx: 16.824,
													cy: 16.824,
													r: 16.824,
													transform: "translate(11.316 3.081)",
													fill: "#423e3a"
												})
											]
										}), /* @__PURE__ */ _jsx("circle", {
											id: "Ellipse_25",
											"data-name": "Ellipse 25",
											cx: 4.562,
											cy: 4.562,
											r: 4.562,
											transform: "translate(13.74 9.782)",
											fill: "#fff"
										})]
									}), /* @__PURE__ */ _jsxs("g", {
										id: "Gruppe_67",
										"data-name": "Gruppe 67",
										transform: "translate(108.355 8.58)",
										children: [/* @__PURE__ */ _jsxs("g", {
											id: "Gruppe_66",
											"data-name": "Gruppe 66",
											children: [
												/* @__PURE__ */ _jsx("path", {
													id: "Pfad_98",
													"data-name": "Pfad 98",
													d: "M930.243,388.5c1-12.4-12.547-22.385-24.951-23.383s-26.377,10.266-27.375,22.67,11.406,21.1,23.81,22.1S929.245,400.763,930.243,388.5Z",
													transform: "translate(-877.718 -365.057)",
													fill: "#3d1629"
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Pfad_99",
													"data-name": "Pfad 99",
													d: "M930.143,390.1c1-12.4-12.547-22.385-24.951-23.383s-26.377,10.266-27.375,22.67,11.406,21.1,23.81,22.1S929.145,402.505,930.143,390.1Z",
													transform: "translate(-877.76 -364.375)",
													fill: "#fff"
												}),
												/* @__PURE__ */ _jsx("circle", {
													id: "Ellipse_26",
													"data-name": "Ellipse 26",
													cx: 16.824,
													cy: 16.824,
													r: 16.824,
													transform: "translate(13.174 3.341)",
													fill: "#423e3a"
												})
											]
										}), /* @__PURE__ */ _jsx("circle", {
											id: "Ellipse_27",
											"data-name": "Ellipse 27",
											cx: 4.562,
											cy: 4.562,
											r: 4.562,
											transform: "translate(16.025 10.185)",
											fill: "#fff"
										})]
									})]
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Pfad_100",
									"data-name": "Pfad 100",
									d: "M812.6,279.817s.713.143,2,.428A2.456,2.456,0,0,0,812.6,279.817Z",
									transform: "translate(-711.934 -187.658)",
									fill: "#3d1629"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Pfad_101",
									"data-name": "Pfad 101",
									d: "M1005.665,215.5s-7.842,9.41-30.084,12.689c-22.385,3.279-64.16-14.115-111.353-12.975-47.336,1.283-64.445,53.039-64.445,53.039S762,298.481,759.149,334.411s7.414,82.98,7.414,82.98,12.262-40.207,32.365-53.609S831.151,350.237,837,327.71c3.564-13.973,2.281-18.392.57-19.676-1.283-.285-2-.428-2-.428a2.488,2.488,0,0,1,2,.428c7.414,1.853,34.076,9.125,54.037,26.092,23.525,19.961,31.367,21.529,62.734,31.082s62.021,2,62.021,2a169.994,169.994,0,0,0,8.555,30.8c5.846,14.543,16.682,41.49,16.682,41.49a140.727,140.727,0,0,1,9.838-23.24c6.986-13.4,8.84-22.385,10.551-32.222,1.853-9.838,1.426-16.967.428-30.084s-5.418-20.531-5.418-20.531,5.846-10.551,10.551-18.25c4.563-7.7,1-24.951,1-24.951-17.109,13.687-29.514-7.414-29.514-7.414s9.98-12.262,14.115-25.949-4.562-18.392-4.562-18.392c-9.7,21.244-41.2,12.689-41.2,12.689s.428-5.988,1.568-18.963S1005.665,215.5,1005.665,215.5Z",
									transform: "translate(-734.905 -215.162)",
									fill: "#423e3a"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Pfad_102",
									"data-name": "Pfad 102",
									d: "M845.392,338.648l.143-7.842s-40.064-5.846-55.035,29.8C790.5,360.605,810.6,331.662,845.392,338.648Z",
									transform: "translate(-721.344 -166.076)",
									fill: "#3d1629"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Pfad_103",
									"data-name": "Pfad 103",
									d: "M939.057,373.711c-9.125-37.64-49.617-38.211-49.617-38.211l-1.141,7.842C923.659,341.916,939.057,373.711,939.057,373.711Z",
									transform: "translate(-679.703 -163.926)",
									fill: "#3d1629"
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Gruppe_70",
									"data-name": "Gruppe 70",
									transform: "translate(133.013 291.036)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Gruppe_69",
										"data-name": "Gruppe 69",
										children: /* @__PURE__ */ _jsx("path", {
											id: "Pfad_104",
											"data-name": "Pfad 104",
											d: "M862.538,442.26h.713c25.521,1.711,28.088-16.111,28.088-16.254a2.352,2.352,0,0,0-2-2.566,2.456,2.456,0,0,0-2.566,1.853c-.143.57-2.139,13.687-23.383,12.4h-.713c-19.818-1.568-22.812-15.969-22.955-16.539a2.238,2.238,0,0,0-4.42.713C835.59,422.3,839.012,440.407,862.538,442.26Z",
											transform: "translate(-835.287 -419.287)",
											fill: "#3d1629"
										})
									})
								})
							]
						})
					]
				})
			]
		})
	})
});
export default SvgBoy;
